import { render, staticRenderFns } from "./challenge_preference_with_groups_with_alternatives.fr.vue?vue&type=template&id=3ce2ba8e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports